import React from 'react'
import OfferEditPanel from "../offerEdit/OfferEditPanel";

function OfferPlacedPanel(
    {
        panelRef,
        sectionId
    }) {
    return <OfferEditPanel panelRef={panelRef} sectionId={sectionId} />
}

export default OfferPlacedPanel;